import React from 'react';
import '../template-file-css/document-file-template.css';


export const NHBC_NursingAssessmentInitial = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='NHBC_NursingAssessmentInitial' className='file-pdf-document'>

            <div className='file-template'>



                <p className='w-750'>
                    <span className='eleHeader'>Contact Type:</span>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" name="cbFaceToFace" id="cbFaceToFace" className='add-only' value="FaceFace" />
                            Face to Face
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" name="cbPhone" id="cbPhone" className='add-only' value="Phone" />
                            Phone
                        </td> 
                    </tr>
                    <tr> 
                        <td className='w-375'>
                            <input type="checkbox" name="cbOther" id="cbOther" className='add-only' value="Other" />
                            Other:
                            <input type="text" id="txtContactOther" name="txtContactOther" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-270'>
                            <span className='eleHeader'>Race</span>
                            <select id="ddlRace" name="ddlRace" className='add-only'>
                                <option value="NA"></option>
                                <option value="AmericanIndian">American Indian or Alaska Native</option>
                                <option value="Asian">Asian</option>
                                <option value="Black">Black or African American</option>
                                <option value="Hispanic">Hispanic or Latino</option>
                                <option value="NativeHawaiian">Native Hawaiian or Other Pacific Islander</option>
                                <option value="White">White</option>
                            </select>


                        </td>
                        <td className='w-80'>
                            <span className='eleHeader'>Age</span>
                            <input type="text" name="txtAge" id="txtAge" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>RN/LPN Staff</span>
                            <input type="text" name="txtStaff" id="txtStaff" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Printed Name</span>
                            <input type="text" name="txtPrintedName" id="txtPrintedName" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h4>LIVING ARRANGEMENTS</h4>
                <p className='w-750'>
                    <span className='eleHeader'>Number in Household</span>
                    <input type="text" name="txtNumberInHousehold" id="txtNumberInHousehold" className='add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Designated Caregiver:</span>
                    <input type="text" name="txtDesignatedCaregiver" id="txtDesignatedCaregiver" className='add-only' />
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Home Conditions:</span>
                            <input type="radio" id="rbClean" name="rbHomeConditions" className='add-only' value="Clean" /> Clean &nbsp;
                            <input type="radio" id="rbUnclean" name="rbHomeConditions" className='add-only' value="Unclean" /> Unclean &nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Safety</span>
                            <input type="radio" id="rbGood" name="rbSafety" className='add-only' value="Good" /> Good &nbsp;
                            <input type="radio" id="rbFair" name="rbSafety" className='add-only' value="Fair" /> Fair &nbsp;
                            <input type="radio" id="rbPoor" name="rbSafety" className='add-only' value="Poor" /> Poor &nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Hygiene:</span>
                            <input type="radio" id="rbGood1" name="rbHygiene" className='add-only' value="Good" /> Good &nbsp;
                            <input type="radio" id="rbFair1" name="rbHygiene" className='add-only' value="Fair" /> Fair &nbsp;
                            <input type="radio" id="rbPoor1" name="rbHygiene" className='add-only' value="Poor" /> Poor &nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea name="txtComments13" id="txtComments13" className='add-only'></textarea>
                </p>
                <h3>VITALS</h3>
                <table>
                    <tr>
                        <td className='w-187'>
                            <span className='eleHeader'>Temperature </span>
                            <input type="text" name="txtTemperature" id="txtTemperature" className='add-only' />
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>Pulse </span>
                            <input type="text" name="txtPulse" id="txtPulse" className='add-only' />
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>Weight </span>
                            <input type="text" name="txtWeight" id="txtWeight" className='add-only' />
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>Height</span>
                            <input type="text" name="txtHeight" id="txtHeight" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <span className='eleHeader'>Blood Pressure </span>
                            <input type="text" name="txtBloodPressure" id="txtBloodPressure" className='add-only' />
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>Respiration </span>
                            <input type="text" name="txtRespiratoryRate" id="txtRespiratoryRate" className='add-only' />
                        </td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                </table>
                <h3>ALLERGIES</h3>
                <p className='w-750'>
                    <span className='eleHeader'>Medications:</span>
                    <textarea name="txtMedications" id="txtMedications" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Food:</span>
                    <textarea name="txtFood" id="txtFood" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Pollens</span>
                    <textarea name="txtPollens" id="txtPollens" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Other:</span>
                    <textarea name="txtOther" id="txtOther" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea name="txtComments" id="txtComments" className='add-only'></textarea>
                </p>
                <h3>IMMUNIZATIONS</h3>
                <p className='w-750'>
                    <span className='eleHeader'>Is child/adolescent up to date on all immunizations?</span>
                </p>
                <p className='w-750'>
                    <input type="radio" id="rbYes" name="rbAllImmunizations" className='add-only' value="Yes" /> Yes &nbsp;
                    <input type="radio" id="rbNo" name="rbAllImmunizations" className='add-only' value="No" /> No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Have you ever received Blood/blood products?</span>
                </p>
                <p className='w-750'>
                    <input type="radio" id="rbYes1" name="rbEverReceived" className='add-only' value="Yes" /> Yes &nbsp;
                    <input type="radio" id="rbNo1" name="rbEverReceived" className='add-only' value="No" /> No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea name="txtComments1" id="txtComments1" className='add-only'></textarea>
                </p>
                <h3>Cultural/Spiritual</h3>
                <p className='w-750'>
                    <span className='eleHeader'>Religious Affiliation:</span>
                    <textarea name="txtReligiousAffiliation" id="txtReligiousAffiliation" className='add-only'></textarea>
                </p>
                <h3>SURGICAL HISTORY</h3>
                <table>
                    <tr>
                        <td className='w-50'>
                            <span className='eleHeader'>NO:</span>
                            <input type="text" name="txtNo" id="txtNo" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>SURGERY</span>
                            <input type="text" name="txtSurgery" id="txtSurgery" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>DATE:</span>
                            <input type="date" name="txtDate" id="txtDate" className='add-only' />
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>NO:</span>
                            <input type="text" name="txtNo1" id="txtNo1" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>SURGERY</span>
                            <input type="text" name="txtSurgery1" id="txtSurgery1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="text" name="txtNo2" id="txtNo2" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" name="txtSurgery2" id="txtSurgery2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="date" name="txtDate1" id="txtDate1" className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type="text" name="txtNo3" id="txtNo3" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" name="txtSurgery3" id="txtSurgery3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="text" name="txtNo4" id="txtNo4" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" name="txtSurgery4" id="txtSurgery4" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="date" name="txtDate2" id="txtDate2" className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type="text" name="txtNo5" id="txtNo5" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" name="txtSurgery5" id="txtSurgery5" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="text" name="txtNo6" id="txtNo6" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" name="txtSurgery6" id="txtSurgery6" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="date" name="txtDate3" id="txtDate3" className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type="text" name="txtNo7" id="txtNo7" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type="text" name="txtSurgery7" id="txtSurgery7" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>MEDICATIONS</h3>
                <table>
                    <tr>
                        <td className='w-140'>
                            <span className='eleHeader'>MEDICATION</span>
                            <input type="text" name="txtMedication" id="txtMedication" className='add-only' />
                        </td>
                        <td className='w-120'>
                            <span className='eleHeader'>DOSAGE</span>
                            <input type="text" name="txtDosage" id="txtDosage" className='add-only' />
                        </td>
                        <td className='w-80'>
                            <span className='eleHeader'>FREQUENCY</span>
                            <input type="text" name="txtFrequency" id="txtFrequency" className='add-only' />
                        </td>
                        <td className='w-230'>
                            <span className='eleHeader'>DATE OF RX</span>
                            <input type="date" name="txtDate4" id="txtDate4" className='add-only' />
                        </td>
                        <td className='w-180'>
                            <span className='eleHeader'>PHYSICIAN</span>
                            <input type="text" name="txtPhysician" id="txtPhysician" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-140'>
                            <input type="text" name="txtMedication1" id="txtMedication1" className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type="text" name="txtDosage1" id="txtDosage1" className='add-only' />
                        </td>
                        <td className='w-80'>
                            <input type="text" name="txtFrequency1" id="txtFrequency1" className='add-only' />
                        </td>
                        <td className='w-230'>
                            <input type="date" name="txtDate5" id="txtDate5" className='add-only' />
                        </td>
                        <td className='w-180'>
                            <input type="text" name="txtPhysician1" id="txtPhysician1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-140'>
                            <input type="text" name="txtMedication2" id="txtMedication2" className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type="text" name="txtDosage2" id="txtDosage2" className='add-only' />
                        </td>
                        <td className='w-80'>
                            <input type="text" name="txtFrequency2" id="txtFrequency2" className='add-only' />
                        </td>
                        <td className='w-230'>
                            <input type="date" name="txtDate6" id="txtDate6" className='add-only' />
                        </td>
                        <td className='w-180'>
                            <input type="text" name="txtPhysician2" id="txtPhysician2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-140'>
                            <input type="text" name="txtMedication3" id="txtMedication3" className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type="text" name="txtDosage3" id="txtDosage3" className='add-only' />
                        </td>
                        <td className='w-80'>
                            <input type="text" name="txtFrequency3" id="txtFrequency3" className='add-only' />
                        </td>
                        <td className='w-230'>
                            <input type="date" name="txtDate7" id="txtDate7" className='add-only' />
                        </td>
                        <td className='w-180'>
                            <input type="text" name="txtPhysician3" id="txtPhysician3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-140'>
                            <input type="text" name="txtMedication4" id="txtMedication4" className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type="text" name="txtDosage4" id="txtDosage4" className='add-only' />
                        </td>
                        <td className='w-80'>
                            <input type="text" name="txtFrequency4" id="txtFrequency4" className='add-only' />
                        </td>
                        <td className='w-230'>
                            <input type="date" name="txtDate8" id="txtDate8" className='add-only' />
                        </td>
                        <td className='w-180'>
                            <input type="text" name="txtPhysician4" id="txtPhysician4" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-140'>
                            <input type="text" name="txtMedication5" id="txtMedication5" className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type="text" name="txtDosage5" id="txtDosage5" className='add-only' />
                        </td>
                        <td className='w-80'>
                            <input type="text" name="txtFrequency5" id="txtFrequency5" className='add-only' />
                        </td>
                        <td className='w-230'>
                            <input type="date" name="txtDate9" id="txtDate9" className='add-only' />
                        </td>
                        <td className='w-180'>
                            <input type="text" name="txtPhysician5" id="txtPhysician5" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Are there any recent changes in medications?</span>
                </p>
                <p className='w-750'>
                    <input type="radio" id="rbYes2" name="rbRecentChanges" className='add-only' value="Yes" /> Yes &nbsp;
                    <input type="radio" id="rbNo2" name="rbRecentChanges" className='add-only' value="No" /> No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>If yes, explain:</span>
                    <textarea name="txtExplain" id="txtExplain" className='add-only'></textarea>
                </p>
                <h3>AT RISK BEHAVIORS</h3>
                <table>
                    <tr>
                        <td className='w-50'>
                            <span className='eleHeader'>No:</span>
                        </td>
                        <td className='w-500'>
                            <span className='eleHeader'>Questions</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>Yes:</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>No:</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>Don't Know:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>1
                        </td>
                        <td className='w-500'>Have you ever had Hepatitis?
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbHepatitis" id="cbHepatitis" className='add-only' value="Hepatitis" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbHepatitis1" id="cbHepatitis1" className='add-only' value="Hepatitis1" />
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" name="cbHepatitis2" id="cbHepatitis2" className='add-only' value="Hepatitis2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>2
                        </td>
                        <td className='w-500'>Have you ever used intravenous (IV) drugs?
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbEverUsed" id="cbEverUsed" className='add-only' value="EverUsed" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbEverUsed1" id="cbEverUsed1" className='add-only' value="EverUsed1" />
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" name="cbEverUsed2" id="cbEverUsed2" className='add-only' value="EverUsed2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>3
                        </td>
                        <td className='w-500'>Have you ever shared needles/syringes with others?
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbSyringes" id="cbSyringes" className='add-only' value="Syringes" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbSyringes1" id="cbSyringes1" className='add-only' value="Syringes1" />
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" name="cbSyringes2" id="cbSyringes2" className='add-only' value="Syringes2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>4
                        </td>
                        <td className='w-500'>Have you ever had any disease spread through sex?
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbAnyDisease" id="cbAnyDisease" className='add-only' value="AnyDisease" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbAnyDisease1" id="cbAnyDisease1" className='add-only' value="AnyDisease1" />
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" name="cbAnyDisease2" id="cbAnyDisease2" className='add-only' value="AnyDisease2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>5
                        </td>
                        <td className='w-500'>Have you ever had open sores on sex organs or genitals?
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbGenitals" id="cbGenitals" className='add-only' value="Genitals" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbGenitals1" id="cbGenitals1" className='add-only' value="Genitals1" />
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" name="cbGenitals2" id="cbGenitals2" className='add-only' value="Genitals2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>6
                        </td>
                        <td className='w-500'>Have you ever been raped or molested?
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbMolested" id="cbMolested" className='add-only' value="Molested" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbMolested1" id="cbMolested1" className='add-only' value="Molested1" />
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" name="cbMolested2" id="cbMolested2" className='add-only' value="Molested2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>7
                        </td>
                        <td className='w-500'>Have you ever traded sex for drugs or money?
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbDrugs" id="cbDrugs" className='add-only' value="Drugs" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbDrugs1" id="cbDrugs1" className='add-only' value="Drugs1" />
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" name="cbDrugs2" id="cbDrugs2" className='add-only' value="Drugs2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>8
                        </td>
                        <td className='w-500'>With whom have you had sex in the past?
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbPast" id="cbPast" className='add-only' value="Past" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbPast1" id="cbPast1" className='add-only' value="Past1" />
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" name="cbPast2" id="cbPast2" className='add-only' value="Past2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>9a
                        </td>
                        <td className='w-500'>Same sex Partner?
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbSexPartner" id="cbSexPartner" className='add-only' value="SexPartner" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbSexPartner1" id="cbSexPartner1" className='add-only' value="SexPartner1" />
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" name="cbSexPartner2" id="cbSexPartner2" className='add-only' value="SexPartner2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>9b
                        </td>
                        <td className='w-500'>Opposite sex Partner?
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbSexPartner3" id="cbSexPartner3" className='add-only' value="SexPartner3" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbSexPartner4" id="cbSexPartner4" className='add-only' value="SexPartner4" />
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" name="cbSexPartner5" id="cbSexPartner5" className='add-only' value="SexPartner5" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>9c
                        </td>
                        <td className='w-500'>Bisexual Partner?
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbBisexualPartner" id="cbBisexualPartner" className='add-only' value="BisexualPartner" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbBisexualPartner1" id="cbBisexualPartner1" className='add-only' value="BisexualPartner1" />
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" name="cbBisexualPartner2" id="cbBisexualPartner2" className='add-only' value="BisexualPartner2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>10
                        </td>
                        <td className='w-500'>Do you use protection such as:
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbProtection" id="cbProtection" className='add-only' value="Protection" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbProtection1" id="cbProtection1" className='add-only' value="Protection1" />
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" name="cbProtection2" id="cbProtection2" className='add-only' value="Protection2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>10a
                        </td>
                        <td className='w-500'>Vaginal Dam? (females)
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbVaginalDam" id="cbVaginalDam" className='add-only' value="VaginalDam" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbVaginalDam1" id="cbVaginalDam1" className='add-only' value="VaginalDam1" />
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" name="cbVaginalDam2" id="cbVaginalDam2" className='add-only' value="VaginalDam2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>10b
                        </td>
                        <td className='w-500'>Condom/Latex Condom
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbCondom" id="cbCondom" className='add-only' value="CondomLatexCondom" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbCondom1" id="cbCondom1" className='add-only' value="CondomLatexCondom1" />
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" name="cbCondom2" id="cbCondom2" className='add-only' value="CondomLatexCondom2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>10c
                        </td>
                        <td className='w-500'>Latex condom with spermicidal (jelly, foam, cream)?
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbLatexCondom" id="cbLatexCondom" className='add-only' value="LatexCondom" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbLatexCondom1" id="cbLatexCondom1" className='add-only' value="LatexCondom1" />
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" name="cbLatexCondom2" id="cbLatexCondom2" className='add-only' value="LatexCondom2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>11
                        </td>
                        <td className='w-500'>Are you aware of your sexual partner's history?
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbHistory" id="cbHistory" className='add-only' value="History" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbHistory1" id="cbHistory1" className='add-only' value="History1" />
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" name="cbHistory2" id="cbHistory2" className='add-only' value="History2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>12
                        </td>
                        <td className='w-500'>Have you ever been tested for HIV?
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbEverBeenTested" id="cbEverBeenTested" className='add-only' value="EverBeenTested" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbEverBeenTested1" id="cbEverBeenTested1" className='add-only' value="EverBeenTested1" />
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" name="cbEverBeenTested2" id="cbEverBeenTested2" className='add-only' value="EverBeenTested2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>13</td>
                        <td className='w-700'>
                        How many partners have you had in the last month &nbsp;
                            <input type="text" name="txtLastMonth" id="txtLastMonth" className='add-only w-150 custom-add-only' /> &nbsp;
                            year: <input type="text" name="txtYear" id="txtYear" className='add-only w-120 custom-add-only' />

                        </td>
                    </tr> 
                    <tr>
                        <td className='w-750'> 14 Do you wish to be tested for HIV? &nbsp;
                            <input type="radio" id="rbYes3" name="rbTested" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbNo3" name="rbTested" className='add-only' value="No" /> No
                        </td>
                    </tr>
                </table>
                <h3>MEDICAL HISTORY</h3>
                <table>
                    <tr>
                        <td className='w-50'>
                            <span className='eleHeader'>No:</span>
                        </td>
                        <td className='w-500'>
                            <span className='eleHeader'>Does anyone if your family have the following</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>Yes:</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>No:</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>Don't Know:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>1
                        </td>
                        <td className='w-500'>Blood disease (phlebitis, hemophilia, sickle cell)
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbBloodDisease" id="cbBloodDisease" className='add-only' value="BloodDisease" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbBloodDisease1" id="cbBloodDisease1" className='add-only' value="BloodDisease1" />
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" name="cbBloodDisease2" id="cbBloodDisease2" className='add-only' value="BloodDisease2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>2
                        </td>
                        <td className='w-500'>Bone & Joint disorders
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbJointDisorders" id="cbJointDisorders" className='add-only' value="JointDisorders" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbJointDisorders1" id="cbJointDisorders1" className='add-only' value="JointDisorders1" />
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" name="cbJointDisorders2" id="cbJointDisorders2" className='add-only' value="JointDisorders2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>3
                        </td>
                        <td className='w-500'>Lung Disease (bronchitis, asthma, emphysema)
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbLungDisease" id="cbLungDisease" className='add-only' value="LungDisease" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbLungDisease1" id="cbLungDisease1" className='add-only' value="LungDisease2" />
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" name="cbLungDisease2" id="cbLungDisease2" className='add-only' value="LungDisease3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>4
                        </td>
                        <td className='w-500'>Hearing defects
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbHearingDefects" id="cbHearingDefects" className='add-only' value="HearingDefects" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbHearingDefects1" id="cbHearingDefects1" className='add-only' value="HearingDefects1" />
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" name="cbHearingDefects2" id="cbHearingDefects2" className='add-only' value="HearingDefects2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>5
                        </td>
                        <td className='w-500'>Eye disease
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbEyeDisease" id="cbEyeDisease" className='add-only' value="Eyedisease" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbEyeDisease1" id="cbEyeDisease1" className='add-only' value="Eyedisease1" />
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" name="cbEyeDisease2" id="cbEyeDisease2" className='add-only' value="Eyedisease2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>6
                        </td>
                        <td className='w-500'>Glandular Disease (thyroid, diabetes)
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbGlandularDisease" id="cbGlandularDisease" className='add-only' value="GlandularDisease" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbGlandularDisease1" id="cbGlandularDisease1" className='add-only' value="GlandularDisease1" />
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" name="cbGlandularDisease2" id="cbGlandularDisease2" className='add-only' value="GlandularDisease2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>7
                        </td>
                        <td className='w-500'>Heart trouble (stroke, heart attack)
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbHeartTrouble" id="cbHeartTrouble" className='add-only' value="HeartTrouble" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbHeartTrouble1" id="cbHeartTrouble1" className='add-only' value="HeartTrouble1" />
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" name="cbHeartTrouble2" id="cbHeartTrouble2" className='add-only' value="HeartTrouble2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>8
                        </td>
                        <td className='w-500'>High blood pressure
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbBloodPressure" id="cbBloodPressure" className='add-only' value="BloodPressure" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbBloodPressure1" id="cbBloodPressure1" className='add-only' value="BloodPressure1" />
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" name="cbBloodPressure2" id="cbBloodPressure2" className='add-only' value="BloodPressure2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>9
                        </td>
                        <td className='w-500'>Kidney/urinary disease
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbKidney" id="cbKidney" className='add-only' value="Kidney" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbKidney1" id="cbKidney1" className='add-only' value="Kidney1" />
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" name="cbKidney2" id="cbKidney2" className='add-only' value="Kidney2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>10
                        </td>
                        <td className='w-500'>Muscle Disease (poor control, weakness)
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbMuscleDisease" id="cbMuscleDisease" className='add-only' value="MuscleDisease" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbMuscleDisease1" id="cbMuscleDisease1" className='add-only' value="MuscleDisease1" />
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" name="cbMuscleDisease2" id="cbMuscleDisease2" className='add-only' value="MuscleDisease2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>11
                        </td>
                        <td className='w-500'>Nerve Disease (cerebral palsy, epilepsy)
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbNerveDisease" id="cbNerveDisease" className='add-only' value="NerveDisease" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbNerveDisease1" id="cbNerveDisease1" className='add-only' value="NerveDisease1" />
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" name="cbNerveDisease2" id="cbNerveDisease2" className='add-only' value="NerveDisease2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>12
                        </td>
                        <td className='w-500'>Psychiatric Conditions
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbPsychiatricConditions" id="cbPsychiatricConditions" className='add-only' value="PsychiatricConditions" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbPsychiatricConditions1" id="cbPsychiatricConditions1" className='add-only' value="PsychiatricConditions1" />
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" name="cbPsychiatricConditions2" id="cbPsychiatricConditions2" className='add-only' value="PsychiatricConditions2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>13
                        </td>
                        <td className='w-500'>Blood transfusion
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbBloodTransfusion" id="cbBloodTransfusion" className='add-only' value="Bloodtransfusion" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbBloodTransfusion1" id="cbBloodTransfusion1" className='add-only' value="Bloodtransfusion1" />
                        </td>
                        <td className='w-100'>
                            <input type="checkbox" name="cbBloodTransfusion2" id="cbBloodTransfusion2" className='add-only' value="Bloodtransfusion2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>14
                        </td>
                        <td className='w-500'>Other
                        </td>
                        <td className='w-50'>&nbsp;</td>
                        <td className='w-50'>&nbsp;</td>
                        <td className='w-100'>&nbsp;</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea name="txtOther5" id="txtOther5" className='add-only'></textarea>
                </p>
                <h3>PSYCHIATRIC HISTORY</h3>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Psychiatric History:</span>
                            <input type="radio" id="rbYes4" name="rbPsychiatricHistory" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbNo4" name="rbPsychiatricHistory" className='add-only' value="No" /> No &nbsp;
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Previous Psychiatric Hospitalizations:</span>
                            <input type="radio" id="rbYes5" name="rbHospitalizations" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbNo5" name="rbHospitalizations" className='add-only' value="No" /> No &nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>If yes, explain:</span>
                    <textarea name="txtExplain4" id="txtExplain4" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Previous Mental Health Services:</span>
                </p>
                <p className='w-750'>
                    <input type="radio" id="rbYes6" name="rbMentalHealth" className='add-only' value="Yes" /> Yes &nbsp;
                    <input type="radio" id="rbNo6" name="rbMentalHealth" className='add-only' value="No" /> No &nbsp;
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Dates of Treatment:</span>
                    <textarea name="txtTreatment" id="txtTreatment" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Other Laboratory Testing</span>
                    <span className='small'>(Required for Addictive Disease Assessments)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>RPR:</span>
                            <input type="text" name="txtRPR" id="txtRPR" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>PPD:</span>
                            <input type="text" name="txtPPD" id="txtPPD" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>UDS:</span>
                            <input type="text" name="txtUDS" id="txtUDS" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>HIV Risk Assessment:</span>
                    <textarea name="txtRiskAssessment" id="txtRiskAssessment" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Other labs suggested?</span>
                    <span className='small'>(HIV, Hep B, Pregnancy test, CBC, UA, other):</span>
                </p>
                <p className='w-750'>
                    <textarea name="txtLabsSuggested" id="txtLabsSuggested" className='add-only'></textarea>
                </p>
                <h3>NUTRITIONAL HISTORY</h3>
                <p className='w-750'>
                    <span className='eleHeader'>How would you describe your meal:</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="cbCarbohydrateCounting" id="cbCarbohydrateCounting" className='add-only' value="Carbohydratecounting" />
                            Carbohydrate counting
                        </td>
                        <td className='w-200'>
                            <input type="checkbox" name="cbSpecificPlan" id="cbSpecificPlan" className='add-only' value="Nospecificplan" />
                            No specific plan
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbLowFat" id="cbLowFat" className='add-only' value="Lowfat" />
                            Low-fat
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="cbLowSugar" id="cbLowSugar" className='add-only' value="Lowsugar" />
                            Low-sugar
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="cbHighProtein" id="cbHighProtein" className='add-only' value="Lowcarbhighprotein" />
                            Low-carb high protein
                        </td>
                        <td className='w-200'>
                            <input type="checkbox" name="cbAddedSalt" id="cbAddedSalt" className='add-only' value="Yesnoaddedsalt" />
                            Yes no added salt
                        </td>
                        <td className='w-200'>&nbsp;</td>
                        <td className='w-200'>&nbsp;</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Who Cooks?</span>
                    <textarea name="txtWhoRisks" id="txtWhoRisks" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>How often do you eat out?</span>
                    <textarea name="txtDoYouEat" id="txtDoYouEat" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Do you know about the major food groups?</span>
                </p>
                <p className='w-750'>
                    <input type="radio" id="rbYes7" name="rbFoodGroups" className='add-only' value="Yes" /> Yes &nbsp;
                    <input type="radio" id="rbNo7" name="rbFoodGroups" className='add-only' value="No" /> No &nbsp;
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>How to prepare a nutritious meal?</span>
                </p>
                <p className='w-750'>
                    <input type="radio" id="rbYes8" name="rbNutritiousMeal" className='add-only' value="Yes" /> Yes &nbsp;
                    <input type="radio" id="rbNo8" name="rbNutritiousMeal" className='add-only' value="No" /> No &nbsp;
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Do you know how to shop for nutritious meals?</span>
                </p>
                <p className='w-750'>
                    <input type="radio" id="rbYes9" name="rbNutritiousMeal1" className='add-only' value="Yes" /> Yes &nbsp;
                    <input type="radio" id="rbNo9" name="rbNutritiousMeal1" className='add-only' value="No" /> No &nbsp;
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Would you like additional education:</span>
                </p>
                <p className='w-750'>
                    <input type="radio" id="rbYes10" name="rbAdditionalEducation" className='add-only' value="Yes" /> Yes &nbsp;
                    <input type="radio" id="rbNo10" name="rbAdditionalEducation" className='add-only' value="No" /> No &nbsp;
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea name="txtComments2" id="txtComments2" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>SKIN</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>Yes</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>No</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Jaundice </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbJaundice" id="cbJaundice" className='add-only' value="Jaundice" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbJaundice1" id="cbJaundice1" className='add-only' value="Jaundice1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Rash
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbRash" id="cbRash" className='add-only' value="Rash" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbRash1" id="cbRash1" className='add-only' value="Rash1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Open Wounds
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbOpenWounds" id="cbOpenWounds" className='add-only' value="OpenWounds" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbOpenWounds1" id="cbOpenWounds1" className='add-only' value="OpenWounds1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Incision/Scars
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbScars" id="cbScars" className='add-only' value="IncisionScars" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbScars1" id="cbScars1" className='add-only' value="IncisionScars1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Itching
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbItching" id="cbItching" className='add-only' value="Itching" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbItching1" id="cbItching1" className='add-only' value="Itching1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Tattoos
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbTattoos" id="cbTattoos" className='add-only' value="Tattoos" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbTattoos1" id="cbTattoos1" className='add-only' value="Tattoos1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Edema
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbEdema" id="cbEdema" className='add-only' value="Edema" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbEdema1" id="cbEdema1" className='add-only' value="Edema1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Bruises
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbBruises" id="cbBruises" className='add-only' value="Bruises" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbBruises1" id="cbBruises1" className='add-only' value="Bruises1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Hydrated
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbHydrated" id="cbHydrated" className='add-only' value="Hydrated" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbHydrated1" id="cbHydrated1" className='add-only' value="Hydrated1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Piercing
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbPiercing" id="cbPiercing" className='add-only' value="Piercing" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbPiercing1" id="cbPiercing1" className='add-only' value="Piercing1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Observe any additional marks on ADM
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbAdditionalMarks" id="cbAdditionalMarks" className='add-only' value="AdditionalMarks" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbAdditionalMarks1" id="cbAdditionalmarks1" className='add-only' value="AdditionalMarks1" />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea name="txtComments3" id="txtComments3" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>EYES</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>Yes</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>No</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Contacts:
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbContacts" id="cbContacts" className='add-only' value="Contacts" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbContacts1" id="cbContacts1" className='add-only' value="Contacts1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Glasses:
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbGlasses" id="cbGlasses" className='add-only' value="Glasses" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbGlasses1" id="cbGlasses1" className='add-only' value="Glasses1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Blurred Vision:
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbBlurredVision" id="cbBlurredVision" className='add-only' value="BlurredVision" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbBlurredVision1" id="cbBlurredVision1" className='add-only' value="BlurredVision1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Redness:
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbRedness" id="cbRedness" className='add-only' value="Redness" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbRedness1" id="cbRedness1" className='add-only' value="Redness1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Inflammation:
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbInflammation" id="cbInflammation" className='add-only' value="Inflammation" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbInflammation1" id="cbInflammation1" className='add-only' value="Inflammation1" />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea name="txtComments4" id="txtComments4" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>EARS</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>Yes</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>No</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Hearing Difficulty
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbHearingDifficulty" id="cbHearingDifficulty" className='add-only' value="HearingDifficulty" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbHearingDifficulty1" id="cbHearingDifficulty1" className='add-only' value="HearingDifficulty1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Hearing Aid
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbHearingAid" id="cbHearingAid" className='add-only' value="HearingAid" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbHearingAid1" id="cbHearingAid1" className='add-only' value="HearingAid1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Earaches
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbEaraches" id="cbEaraches" className='add-only' value="Earaches" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbEaraches1" id="cbEaraches1" className='add-only' value="Earaches1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Dizziness
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbDizziness" id="cbDizziness" className='add-only' value="Dizziness" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbDizziness1" id="cbDizziness1" className='add-only' value="Dizziness1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Ringing
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbRinging" id="cbRinging" className='add-only' value="Ringing" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbRinging1" id="cbRinging1" className='add-only' value="Ringing1" />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea name="txtComments5" id="txtComments5" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>NOSE AND THROAT</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>Yes</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>No</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Sinus Congestion
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbSinusCongestion" id="cbSinusCongestion" className='add-only' value="SinusCongestion" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbSinusCongestion1" id="cbSinusCongestion1" className='add-only' value="SinusCongestion1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Nose Bleeds
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbNoseBleeds" id="cbNoseBleeds" className='add-only' value="NoseBleeds" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbNoseBleeds1" id="cbNoseBleeds1" className='add-only' value="NoseBleeds1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Sore Throat
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbSoreThroat" id="cbSoreThroat" className='add-only' value="SoreThroat" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbSoreThroat1" id="cbSoreThroat1" className='add-only' value="SoreThroat1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Difficulty Swallowing
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbDifficultySwallowing" id="cbDifficultySwallowing" className='add-only' value="DifficultySwallowing" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbDifficultySwallowing1" id="cbDifficultySwallowing1" className='add-only' value="DifficultySwallowing1" />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea name="txtComments6" id="txtComments6" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>REPRODUCTIVE:</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>Yes</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>No</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Penile Discharge
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbPenileDischarge" id="cbPenileDischarge" className='add-only' value="PenileDischarge" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbPenileDischarge1" id="cbPenileDischarge1" className='add-only' value="PenileDischarge1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Penile Pain/Tenderness
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbTenderness" id="cbTenderness" className='add-only' value="PenilePainTenderness" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbTenderness1" id="cbTenderness1" className='add-only' value="PenilePainTenderness1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Scrotal Pain/Swelling
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbSwelling" id="cbSwelling" className='add-only' value="ScrotalPainSwelling" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbSwelling1" id="cbSwelling1" className='add-only' value="ScrotalPainSwelling1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>LMP
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbLMP" id="cbLMP" className='add-only' value="LMP" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbLMP1" id="cbLMP1" className='add-only' value="LMP1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Breast Problems
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbBreastProblems" id="cbBreastProblems" className='add-only' value="BreastProblems" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbBreastProblems1" id="cbBreastProblems1" className='add-only' value="BreastProblems1" />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea name="txtComments7" id="txtComments7" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>MOUTH:</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>Yes</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>No</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Retainers
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbRetainers" id="cbRetainers" className='add-only' value="Retainers" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbRetainers1" id="cbRetainers1" className='add-only' value="Retainers1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Bloody Gums
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbBloodyGums" id="cbBloodyGums" className='add-only' value="BloodyGums" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbBloodyGums1" id="cbBloodyGums1" className='add-only' value="BloodyGums1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Toothache
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbToothache" id="cbToothache" className='add-only' value="Toothache" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbToothache1" id="cbToothache1" className='add-only' value="Toothache1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Braces
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbBraces" id="cbBraces" className='add-only' value="Braces" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbBraces1" id="cbBraces1" className='add-only' value="Braces1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Cavities
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbCavities" id="cbCavities" className='add-only' value="Cavities" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbCavities1" id="cbCavities1" className='add-only' value="Cavities1" />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea name="txtComments8" id="txtComments8" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>RESPIRATORY</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>Yes</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>No</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Wheezing
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbWheezing" id="cbWheezing" className='add-only' value="Wheezing" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbWheezing1" id="cbWheezing1" className='add-only' value="Wheezing1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Dyspnea
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbDyspnea" id="cbDyspnea" className='add-only' value="Dyspnea" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbDyspnea1" id="cbDyspnea1" className='add-only' value="Dyspnea1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Hemoptysis
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbHemoptysis" id="cbHemoptysis" className='add-only' value="Hemoptysis" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbHemoptysis1" id="cbHemoptysis1" className='add-only' value="Hemoptysis" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Cough
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbCough" id="cbCough" className='add-only' value="Cough" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbCough1" id="cbCough1" className='add-only' value="Cough1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Asthma
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbAsthma" id="cbAsthma" className='add-only' value="Asthma" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbAsthma1" id="cbAsthma1" className='add-only' value="Asthma1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Smoker
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbSmoker" id="cbSmoker" className='add-only' value="Smoker" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbSmoker1" id="cbSmoker1" className='add-only' value="Smoker1" />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    Other
                    <input type="text" name="txtOther1" id="txtOther1" className='add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea name="txtComments9" id="txtComments9" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>CARDIOVASCULAR</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>Yes</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>No</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>High Blood Pressure
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbHighBlood" id="cbHighBlood" className='add-only' value="HighBloodPressure" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbHighBlood1" id="cbHighBlood1" className='add-only' value="HighBloodPressure1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Chest Pain
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbChestPain" id="cbChestPain" className='add-only' value="ChestPain" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbChestPain1" id="cbChestPain1" className='add-only' value="ChestPain1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Palpitations
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbPalpitations" id="cbPalpitations" className='add-only' value="Palpitations" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbPalpitations1" id="cbPalpitations1" className='add-only' value="Palpitations1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Cardiac Surgery
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbCardiacSurgery" id="cbCardiacSurgery" className='add-only' value="CardiacSurgery" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbCardiacSurgery1" id="cbCardiacSurgery1" className='add-only' value="CardiacSurgery1" />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    Other
                    <input type="text" name="txtOther2" id="txtOther2" className='add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea name="txtComments10" id="txtComments10" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>GI/GU</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>Yes</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>No</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Abdominal Pain
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbAbdominalPain" id="cbAbdominalPain" className='add-only' value="AbdominalPain" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbAbdominalPain1" id="cbAbdominalPain1" className='add-only' value="AbdominalPain1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Heartburn
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbHeartburn" id="cbHeartburn" className='add-only' value="Heartburn" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbHeartburn1" id="cbHeartburn1" className='add-only' value="Heartburn1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Constipation
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbConstipation" id="cbConstipation" className='add-only' value="Constipation" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbConstipation1" id="cbConstipation1" className='add-only' value="Constipation1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Diarrhea
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbDiarrhea" id="cbDiarrhea" className='add-only' value="Diarrhea" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbDiarrhea1" id="cbDiarrhea1" className='add-only' value="Diarrhea1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Blood in Stool
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbBloodInStool" id="cbBloodInStool" className='add-only' value="BloodInStool" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbBloodInStool1" id="cbBloodInStool1" className='add-only' value="BloodInStool1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Painful Urination
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbPainfulUrination" id="cbPainfulUrination" className='add-only' value="PainfulUrination" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbPainfulUrination1" id="cbPainfulUrination1" className='add-only' value="PainfulUrination1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Increase in Frequency
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbIncreaseInFrequency" id="cbIncreaseInFrequency" className='add-only' value="IncreaseInFrequency" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbIncreaseInFrequency1" id="cbIncreaseInFrequency1" className='add-only' value="IncreaseInFrequency1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Blood in Urine
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbBloodInUrine" id="cbBloodInUrine" className='add-only' value="BloodInUrine" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbBloodInUrine1" id="cbBloodInUrine1" className='add-only' value="BloodInUrine1" />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea name="txtComments11" id="txtComments11" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-300'>
                            <span className='eleHeader'>NEUROLOGICAL</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>Yes</span>
                        </td>
                        <td className='w-50'>
                            <span className='eleHeader'>No</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Headache
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbHeadache" id="cbHeadache" className='add-only' value="Headache" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbHeadache1" id="cbHeadache1" className='add-only' value="Headache1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Fainting
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbFainting" id="cbFainting" className='add-only' value="Fainting" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbFainting1" id="cbFainting1" className='add-only' value="Fainting1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Convulsions
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbConvulsions" id="cbConvulsions" className='add-only' value="Convulsions" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbConvulsions1" id="cbConvulsions1" className='add-only' value="Convulsions1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Insomnia
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbInsomnia" id="cbInsomnia" className='add-only' value="Insomnia" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbInsomnia1" id="cbInsomnia1" className='add-only' value="Insomnia1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Trembling
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbTrembling" id="cbTrembling" className='add-only' value="Trembling" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbTrembling1" id="cbTrembling1" className='add-only' value="Trembling1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Disoriented
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbDisoriented" id="cbDisoriented" className='add-only' value="Disoriented" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbDisoriented1" id="cbDisoriented1" className='add-only' value="Disoriented1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>Drug Use:
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbDrugUse" id="cbDrugUse" className='add-only' value="DrugUse" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbDrugUse1" id="cbDrugUse1" className='add-only' value="DrugUse1" />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    Type
                    <input type="text" name="txtType" id="txtType" className='add-only' />
                </p>
                <table>
                    <tr>
                        <td className='w-300'>Alcohol Use
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbAlcoholUse" id="cbAlcoholUse" className='add-only' value="AlcoholUse" />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="cbAlcoholUse1" id="cbAlcoholUse1" className='add-only' value="AlcoholUse1" />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    Type
                    <input type="text" name="txtType1" id="txtType1" className='add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea name="txtComments12" id="txtComments12" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>REFERRALS</span>
                </p>
                <table>
                    <tr>
                        <td className='w-280'>
                            <input type="checkbox" name="cbAlcohol" id="cbAlcohol" className='add-only' value="Alcohol" />
                            Alcohol/Substance Abuse Education
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="cbNutritionEducation" id="cbNutritionEducation" className='add-only' value="NutritionEducation1" />
                            Fitness and Nutrition Education
                        </td>
                        <td className='w-200'>
                            <input type="checkbox" name="cbAIDSEducation" id="cbAIDSEducation" className='add-only' value="AIDSEducation" />
                            HIV/AIDS Education
                        </td>
                    </tr>
                    <tr>
                        <td className='w-280'>
                            <input type="checkbox" name="cbTreatmentReferral" id="cbTreatmentReferral" className='add-only' value="TreatmentReferral" />
                            HIV/AIDS Testing/Treatment Referral
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="cbPrimaryCare" id="cbPrimaryCare" className='add-only' value="PrimaryCare" />
                            Referral to primary care physician
                        </td>
                        <td className='w-200'>
                            <input type="checkbox" name="cbMedical" id="cbMedical" className='add-only' value="Medical" />
                            Medical follow-up
                        </td>
                    </tr>
                    <tr>
                        <td className='w-280'>
                            <input type="checkbox" name="cbMedicationEducation" id="cbMedicationEducation" className='add-only' value="MedicationEducation" />
                            Medication Education
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="cbHealthEducation" id="cbHealthEducation" className='add-only' value="HealthEducation" />
                            Health Education
                        </td>
                        <td className='w-200'>
                            <input type="checkbox" name="cbSexualEducation" id="cbSexualEducation" className='add-only' value="SexualEducation" />
                            Sexual Education
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" name="cbChronicDisease" id="cbChronicDisease" className='add-only' value="ChronicDiseaseEducationTraining" />
                            Chronic Disease Education/Training
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    Other
                    <input type="text" name="txtOther3" id="txtOther3" className='add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>SUMMARY</span>
                    <textarea name="txtSummary" id="txtSummary" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='signature w-600'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-600'>Nurse Signature/Credentials</td>
                        <td className='small w-150'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature  w-750'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-750'>Please Type/Print Name and Credential</td>
                    </tr>
                </table>

            </div>
        </form>

    )
} 
